import $ from 'jquery';
import CustomAnimation from '../animation/customAnimation';

const customAnmation = new CustomAnimation();

class ModuleDatenschutz {
  init() {
    this.initPage();
    //this.initParallax();
  }

  initPage = () => {

    $('.top-nav').addClass('display_none');
  };

  initParallax = () => {
    customAnmation.animateBubble('.news_blue_bg_bubble', '#news', '20%');
    customAnmation.animateGroup(
      '#datenschutz h1, #datenschutz h2, #datenschutz h3, #datenschutz h4, #datenschutz p'
    );
  };
}

export default ModuleDatenschutz;
